import { render, staticRenderFns } from "./page403.vue?vue&type=template&id=6ba70790&"
import script from "./page403.vue?vue&type=script&lang=js&"
export * from "./page403.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports